import { Component, OnInit } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { filter } from 'rxjs';
import { PropertyManagementCompanyDataService } from '../../../../services/property-management-company/property-manager-company-data.service';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AsyncPipe, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SidenavNavigationItemDirective, SidenavNavigationLoadingDirective } from './header-navigation-sidenav.directive';
import moment from 'moment/moment';
import { SuperAccessDirective } from '../../shared/directives/permission.directive';
import { AnimatedDelayDirective, AnimatedDirective } from '../../shared/directives/animated.directive';

@UntilDestroy()
@Component({
    selector: 'app-sidenav-navigation',
    templateUrl: './header-navigation-sidenav.component.html',
    styleUrls: ['./header-navigation-sidenav.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        RouterLink,
        RouterLinkActive,
        AsyncPipe,
        MatIconModule,
        MatButtonModule,
        SidenavNavigationItemDirective,
        SidenavNavigationLoadingDirective,
        SuperAccessDirective,
        MatMenuModule,
        AnimatedDelayDirective,
        AnimatedDirective,
    ],
})
export class HeaderNavigationSidenavComponent implements OnInit
{
    showNavigation = true;
    showPmcLaunchpad = false;

    constructor(
            private _activatedRoute: ActivatedRoute,
            private _propertyManagementCompanyData: PropertyManagementCompanyDataService,
    ) {
    }

    get pmcId$() {
        return this._activatedRoute.paramMap.pipe(map((params) => +params?.get('pmcId')));
    }

    get orgId$() {
        return this._activatedRoute.paramMap.pipe(map((params) => +params?.get('orgId')));
    }

    ngOnInit() {
        this.pmcId$.pipe(
                filter((pmcId) => !!pmcId),
                switchMap(() => {
                    this.showNavigation = false;
                    return this._propertyManagementCompanyData.pmc$;
                }),
                untilDestroyed(this),
        ).subscribe((pmc) => {
            if (pmc) {
                // TODO: revisit logic for trial period / how long we show the launchpad
                this.showPmcLaunchpad = moment().add(-30, 'days').isBefore(moment(pmc.createdAt));
                this.showNavigation = true;
            }
        });
    }
}
